import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import AgencySelect from '../../../common/forms/select/AgencySelect';
import BankSelect from '../../../common/forms/select/BankSelect';
import Select from '../../../common/forms/select/Select';
import DatePicker from '../../../common/forms/input/DatePicker';
import { BANK_RECONCILIATION_STATUS } from '../../../../config/constants';
import { enumToSelectOptions } from '../../../../utils/enum';

const BankReconciliationSearchForm = ({ handleSubmit }) => (
  <Form onSubmit={handleSubmit}>
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label className="small mb-1">Fecha desde</Label>
          <Field name="from" component={DatePicker} />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label className="small mb-1">Fecha hasta</Label>
          <Field name="to" component={DatePicker} />
        </FormGroup>
      </Col>
    </Row>
    <FormGroup>
      <Label className="small mb-1">Entidad bancaria</Label>
      <Field name="bank" component={BankSelect} isClearable />
    </FormGroup>
    <FormGroup>
      <Label className="small mb-1">Agencia</Label>
      <Field
        name="agency"
        component={AgencySelect}
        isClearable
        visibilityRestricted
      />
    </FormGroup>
    <FormGroup>
      <Label className="small mb-1">Estado de conciliación</Label>
      <Field
        name="status"
        component={Select}
        options={enumToSelectOptions(BANK_RECONCILIATION_STATUS)}
        isMulti
        isClearable
      />
    </FormGroup>
    <div className="text-right">
      <Button color="primary" type="submit">
        <i className="fa fa-search" /> Buscar
      </Button>
    </div>
  </Form>
);

BankReconciliationSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'BankReconciliationSearchForm',
})(BankReconciliationSearchForm);
